var React = require('react');
var PropTypes = React.PropTypes;
import ReactDOM from 'react-dom';

var PartAnswer = React.createClass({
  getInitialState: function() {
    return {
      content: this.props.content
    };
  },

  componentWillReceiveProps: function(nextProps) {
    this.setState({
      content: nextProps.content || this.state.content
    })
  },

  render: function() {
    var content = this.state.content;
    return (
      <div className="padding-15" style={{borderBottom: "1px solid #ccc"}}>
        <h3 style={{fontSize: "20px", margin: "0 0 15px 0"}}>Answer</h3>
        <div dangerouslySetInnerHTML={{__html: content.text}}></div>
      </div>
    );
  },

  componentDidUpdate: function(prevProps) {
    var _this = this;
    window.MathJax.Hub.Queue(["Typeset", window.MathJax.Hub, ReactDOM.findDOMNode(_this)]);
  },

});

module.exports = PartAnswer;



/** WEBPACK FOOTER **
 ** ./src/components/QuestionContent/LongQuestionFraction/PartAnswer.js
 **/